import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, makeStyles } from '@material-ui/core';
import { Typography } from '@klp/design';

const useStyles = makeStyles((theme) => ({
    heading: {
        fontWeight: 'bold',
        color: theme.palette.primary.main,
    },
    numberCell: {
        textAlign: 'right',
    },
}));

type ProsjektAvfallHeaderProps = {
    isEditMode: boolean;
    showAvfallColumns: boolean;
};

export function ProsjektAvfallHeader({
    isEditMode,
    showAvfallColumns,
}: ProsjektAvfallHeaderProps) {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <Grid container={true} spacing={2}>
            <Grid item={true} xs={isEditMode ? 1 : 2}>
                <Typography className={classes.heading}>
                    {showAvfallColumns &&
                        t('sustainability.prosjektAvfall.sorteringHeader')}
                </Typography>
            </Grid>
            <Grid item={true} xs={6}>
                <Typography className={classes.heading}>
                    {showAvfallColumns &&
                        t('sustainability.prosjektAvfall.avfallTypeHeader')}
                </Typography>
            </Grid>
            <Grid item={true} xs={2} className={classes.numberCell}>
                <Typography className={classes.heading}>
                    {t('sustainability.prosjektAvfall.volumHeader')}
                </Typography>
            </Grid>
            <Grid item={true} xs={2} className={classes.numberCell}>
                <Typography className={classes.heading}>
                    {t('sustainability.prosjektAvfall.volumAndelHeader')}
                </Typography>
            </Grid>
        </Grid>
    );
}
